import api from "./api";

const companyContingenciaService = {
  getEstado: async () => {
    const response = await api.get("/company/contingencia/estado");
    return response.data;
  },
  activar: async (tipoContingencia, motivo) => {
    const response = await api.post("/company/contingencia/activar", {
      tipo_contingencia: tipoContingencia,
      motivo: motivo,
    });
    return response.data;
  },
  desactivar: async () => {
    const response = await api.post("/company/contingencia/desactivar");
    return response.data;
  },
  reenviarPendientes: async () => {
    const response = await api.post("/invoices/reenviar-contingencia");
    return response.data;
  },
};

export default companyContingenciaService;